import { ErrorApiResponse } from 'app/types/common';

export const isErrorApiResponse = (error: unknown): error is ErrorApiResponse => {
  return typeof error === 'object' && error != null && 'data' in error;
};
